import * as React from 'react';
import moment from 'moment';

const date_format: string = 'YYYY-MM-DD H:mm:ss';

export const getUTCDate = (date: string, state: any) => {
  let res = date;
  const tz = 'UTC';
  if (tz !== 'UTC') {
    moment.tz.setDefault(tz);
    res = moment(date, date_format)
      .utc()
      .format(date_format);
    moment.tz.setDefault();
  }
  return moment(res).format(date_format);
};

export const mapSearchFields = {
  operations: 'operation',
  loadIds: 'uniqueCustomerTransactionId',
  providerLoadIds: 'uniqueProviderTransactionId',
  customerCodes: 'customerCode',
  providerCodes: 'providerCode',
  responseStatus: 'responseStatus',
  providerCustomerCodes: 'providerCustomerCode',
  statusCodes: 'statusCode',
  aggregator: 'aggregatorCode',
  service: 'service',
  id: 'id',
  shipmentId: 'shipmentId',
  lmd: 'lmd',
  partnerName: 'partnerName',
  ingestionId: 'ingestionId',
  timeTaken: 'timeTaken',
  targetOperation: 'targetOperation',
  targetService: 'targetService',
  receiverCode: 'receiverCode',
  apiResponseTime: 'apiResponseTime',
  retryCount: 'retryCount',
  retryStatus: 'retryStatus',
  requestType: 'requestType'
};

export const filterFields = [
  'operations',
  'loadIds',
  'providerLoadIds',
  'customerCodes',
  'providerCodes',
  'responseStatus',
  'providerCustomerCodes',
  'statusCodes',
  'aggregator',
  'service',
  'id',
  'shipmentId',
  'lmd',
  'partnerName',
  'ingestionId',
  'timeTaken',
  'targetOperation',
  'targetService',
  'receiverCode',
  'apiResponseTime',
  'retryCount',
  'requestType',
  'retryStatus'
];
